import axios from "axios";
import MockAdapter from "axios-mock-adapter";
import { isEmpty } from "lodash";
import { SESSION_KEYS, getDataFromSession } from "src/utils/session-storage";
import { getBase64EncryptedText } from "../utils/methods";
// import * as AxiosLogger from "axios-logger";
import { clearSessionData } from "../utils/session-storage";
const { REACT_APP_ENV } = process.env;
// const ApiClient = setup({
//   withCredentials: true,
//   timeout: 30000,
//   cache: {
//     maxAge: 24 * 60 * 60 * 1000,
//     exclude: {
//       query: false,
//       filter: (config) => {
//         return (
//           config.url.includes("/GetOptionsForSymbol") ||
//           config.url.includes("/GetExpiryForSymbolOptions")
//         );
//       },
//     },
//   },
// });
const ApiClient = axios.create({
    withCredentials: true,
    timeout: 45000,
});
const MockApiClient = new MockAdapter(ApiClient);
if (REACT_APP_ENV === "production" || REACT_APP_ENV === "staging") {
    MockApiClient.restore();
}
MockApiClient.restore();
// ApiClient.interceptors.request.use(AxiosLogger.requestLogger);
ApiClient.interceptors.request.use((request) => {
    if (request.headers) {
        request.headers["AppName"] =
            getDataFromSession(SESSION_KEYS.HOST_NAME) == "charts.5paisa.com"
                ? "CHART_DERIVATIVE"
                : "Derivative360";
        const clientCode = getDataFromSession(SESSION_KEYS.CLIENT_CODE);
        if (clientCode && !isEmpty(clientCode)) {
            request.headers["ClientId"] = getBase64EncryptedText(clientCode);
        }
    }
    return request;
});
ApiClient.interceptors.response.use((resp) => {
    var _a, _b, _c;
    const isInvalidSession = ((_b = (_a = resp === null || resp === void 0 ? void 0 : resp.data) === null || _a === void 0 ? void 0 : _a.head) === null || _b === void 0 ? void 0 : _b.statusDescription) == "Invalid Session";
    const url = (_c = resp.request) === null || _c === void 0 ? void 0 : _c.responseURL;
    if (url &&
        url.includes("CheckLoginResponse")
    // || url.includes("NetPositionNetWise")
    // ||    url.includes("GetOrderUpdates")
    ) {
    }
    else if (isInvalidSession) {
        if (REACT_APP_ENV == "staging" || REACT_APP_ENV == "production") {
            clearSessionData(true);
            window.location.reload();
        }
    }
    return resp;
}, function (error) {
    var _a, _b, _c, _d, _e, _f;
    try {
        const logglyClient = getDataFromSession(SESSION_KEYS.LOGGLY_CLIENT);
        if (logglyClient && ((_a = error === null || error === void 0 ? void 0 : error.config) === null || _a === void 0 ? void 0 : _a.url)) {
            const clientCode = getDataFromSession(SESSION_KEYS.CLIENT_CODE);
            const message = {
                url: (_b = error === null || error === void 0 ? void 0 : error.config) === null || _b === void 0 ? void 0 : _b.url,
                statusCode: (_c = error === null || error === void 0 ? void 0 : error.response) === null || _c === void 0 ? void 0 : _c.status,
                payload: (_d = error === null || error === void 0 ? void 0 : error.config) === null || _d === void 0 ? void 0 : _d.data,
                token: (_f = (_e = error === null || error === void 0 ? void 0 : error.config) === null || _e === void 0 ? void 0 : _e.headers) === null || _f === void 0 ? void 0 : _f.Authorization,
            };
            //logAdvancedMessage("API_ERROR", clientCode, message);
        }
        return Promise.reject(error);
    }
    catch (err) {
        console.error(err);
    }
});
export { ApiClient, MockApiClient };
